import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-job-signoff-artic',
    templateUrl: './job-signoff-artic.component.html',
    styleUrls: ['./job-signoff-artic.component.scss'],
    standalone: false
})
export class JobSignoffArticComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
